export const API_BASE = 'https://sylmguorr8.execute-api.us-west-2.amazonaws.com/prod/'

export const MENU_WIDTH = 260
document.documentElement.style.setProperty('--side-menu-width', `${MENU_WIDTH}px`);
